import {
  Box,
  Button,
  FormControl,
  FormGroup,
  FormHelperText,
  Grid,
  Modal,
  Tooltip,
  Typography,
} from "@mui/material";
import Crossicon from "../../Icon/Crossicon";
import { fontSize } from "../theme/fontSize";
import { fontWeight } from "../theme/fontWeight";
import { FontFamily } from "../theme/fontFamily";
import { ThemeColor } from "../theme/color";
import moment from "moment";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import LeftSideArrow from "../../Icon/LeftSideArrow";
import { useEffect, useState } from "react";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import {
  GetStudentNotesByIdAction,
  GetStudentReminderByIdAction,
} from "../../Redux/action/ApplicationAction";
import {
  AddStudentNotesService,
  DeleteStudentNotesService,
  DeleteStudentReminderService,
  getUnivByOrgIdService,
} from "../../Redux/service/Application";
import ConfirmationModal from "../Modal/ConfirmationModal/ConfirmationModal";
import OutlinedInputField from "../inputfiled/OutlinedInput";
import CustomButton from "../button/button";
import { Form, Formik } from "formik";
import axios from "axios";
import { basicurl } from "../../Redux/ServiceUrl/url";
import Previews from "../dropzone/Mydropzone";
import CustomSelect from "../select field/OutlinedSelectField";
import {
  GetCountryAction,
  GetCurrencyAction,
} from "../../Redux/action/SettingAction";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { sm: "100%", xs: "100%", md: "50%", lg: "50%" },
  height: "50vh",
  overflow: "auto",
  overflowX: "hidden",
  bgcolor: "background.paper",
  border: "2px solid grey",
  boxShadow: 24,
  p: 4,
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#888',
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  },
};

export const DownloadUniBulkUploadTemplateModal = ({ open, handleClose }) => {
  const dispatch = useDispatch();

  const [Countrylist, setCountrylist] = useState([]);
  const [Currencylist, setCurrencylist] = useState([]);

  const CountrylistState = useSelector(
    (state) => state.setting?.countryCount?.data?.data
  );

  useEffect(() => {
    dispatch(GetCountryAction());
    dispatch(GetCurrencyAction());
  }, []);

  useEffect(() => {
    setCountrylist(
      CountrylistState?.map(({ country, ...rest }) => ({
        title: country,
        _id: country,
        ...rest,
      }))
    );
  }, [CountrylistState]);

  const CurrencylistState = useSelector(
    (state) => state.setting?.GetCurrencyList?.data?.currencies
  );

  useEffect(() => {
    // console.log(CountrylistState)
    setCurrencylist(
      CurrencylistState?.map(({ name, symbol, ...rest }) => ({
        title: `${name}(${symbol})`,
        symbol: symbol,
        ...rest,
      }))
    );
  }, [CurrencylistState]);

  const handleGetBulkTemplate = async (values) => {
    try {
      const response = await axios.get(
        `${basicurl}/api/university/download-university-template?country=${values.country}&currency=${values.currency}`,
        {
          responseType: "blob",
        }
      );

      // Create a blob from the response
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create a download link and click it
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "univ_bulk.xlsx"; // 👈 you can set a dynamic filename
      document.body.appendChild(a);
      a.click();
      a.remove();

      // Clean up the blob URL
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <>
      {" "}
      <Modal
        open={open}
        onClose={() => handleClose()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography align="right" onClick={() => handleClose()}>
            <Crossicon width={"20"} height={"20"} />
          </Typography>
          <Typography
            fontFamily={FontFamily.Poppins}
            fontWeight={fontWeight.W600}
            fontSize={fontSize.h3.large}
            color={ThemeColor.BLACK}
            align="center"
          >
            University Bulk Upload
          </Typography>
          <Formik
            className="w-100"
            initialValues={{
              country: "",
              currency: Currencylist?.find(c => c.symbol === "$" || c.title?.includes("USD"))?._id || ""
            }}
            onSubmit={async (values, { resetForm }) => {
              console.log(values);
              handleGetBulkTemplate(values);
              handleClose();
            }}
          >
            {({
              values,
              errors,
              handleBlur,
              handleChange,
              touched,
              handleSubmit,
              setFieldValue,
            }) => (
              <Form className="w-100 d-flex flex-column justify-content-center align-item-center">
                <div className="mt-4">
                  <div className="">
                    <CustomSelect
                      value={Countrylist ? values?.country : ""}
                      name={"country"}
                      multiple={false}
                      option={Countrylist}
                      onBlur={handleBlur}
                      onChange={(e) => {
                        setFieldValue("country", e.target.value);
                      }}
                      fullWidth={true}
                      //   disabled={RoleTypeAgent && true}
                      label={"Country Name *"}
                      helperText={
                        <Typography
                          align="left"
                          // className="px-4"
                          color={ThemeColor.RED}
                          fontSize={fontSize.h4.medium}
                          fontFamily={FontFamily.Lato}
                          fontWeight={fontWeight.W500}
                        >
                          {errors.country}
                        </Typography>
                      }
                    />
                  </div>
                  <div className="">
                    <CustomSelect
                      value={Currencylist ? values?.currency : ""}
                      name={"currency"}
                      multiple={false}
                      option={Currencylist}
                      onBlur={handleBlur}
                      onChange={(e) => {
                        setFieldValue("currency", e.target.value);
                      }}
                      fullWidth={true}
                      //   disabled={RoleTypeAgent && true}
                      label={"Currency Name *"}
                      helperText={
                        <Typography
                          align="left"
                          // className="px-4"
                          color={ThemeColor.RED}
                          fontSize={fontSize.h4.medium}
                          fontFamily={FontFamily.Lato}
                          fontWeight={fontWeight.W500}
                        >
                          {errors.currency}
                        </Typography>
                      }
                    />
                  </div>
                </div>

                <div className="px-3 mt-3 w-100 align-items-center d-flex justify-content-center">
                  <CustomButton
                    variant="contained"
                    type="submit"
                    backgroundColor={ThemeColor.PURPLE}
                    color={ThemeColor.WHITE}
                    // loading={formLoading}
                    padding={"0px"}
                    // onClick={handleClick}
                  >
                    Save
                  </CustomButton>
                </div>
              </Form>
            )}
          </Formik>
        </Box>
      </Modal>
    </>
  );
};
